import React, { forwardRef, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Menu, AccountCircle } from '@material-ui/icons'
import { Button, IconButton } from '@material-ui/core'
import { formatPrice } from '../utils/helpers'
import { loadUser } from '../utils/localStorage'
import theme from '../utils/theme'

const Account = styled(Button)`
  margin: 0 ${props => props.theme.spacing(2)}px;
`
const Login = styled(Button)`
  margin: 0 ${props => props.theme.spacing(2)}px;
`
const Deposit = styled(Button)`
  @media (max-width: 320px) {
    display: none;
  }
`
const Join = styled(Button)`
  margin-right: ${props => props.theme.spacing(2)}px;

  ${theme.breakpoints.down('sm')} {
    display: none;
  }
`
const AccountCircleIcon = styled(AccountCircle)`
  margin-right: ${props => props.theme.spacing(1)}px;
`

const Authentication = ({ data, set }) => {
  // Fetch a user object from local storage
  const persistedUser = loadUser()
  // Check if user has been selected
  const isLoggedIn = !_.isEmpty(data.user)

  // The first time this component mounts we want to
  // retrieve a user from local storage if one exists
  // rather than returning an empty user object
  // This will persist the user login between sessions
  // and browser refreshes
  const mounted = useRef()
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      if (!isLoggedIn && !_.isEmpty(persistedUser)) {
        set({ user: persistedUser })
      }
    }
  })

  // Login link ref forwarded to login button
  const LoginLink = forwardRef((props, ref) => (
    <Link innerRef={ref} to="/users/" {...props} />
  ))

  return (
    <>
      <div style={{ marginLeft: `auto` }}>
        {isLoggedIn ? (
          <>
            <Deposit variant="contained" color="secondary">
              Deposit
            </Deposit>
            <Account
              color="inherit"
              onClick={() => set({ accountMenuOpen: !data.accountMenuOpen })}
            >
              <AccountCircleIcon />
              {formatPrice(data.user.balance * 100)}
            </Account>
          </>
        ) : (
          <>
            <Login component={LoginLink} variant="outlined" color="inherit">
              Log in
            </Login>
            <Join variant="contained" color="secondary">
              Join Now
            </Join>
            <IconButton
              color="inherit"
              onClick={() => set({ accountMenuOpen: !data.accountMenuOpen })}
            >
              <Menu />
            </IconButton>
          </>
        )}
      </div>
    </>
  )
}

Authentication.propTypes = {
  data: PropTypes.object,
  set: PropTypes.func,
}

export default Authentication
